'use client';

import { useEffect, useRef, useState } from 'react';

type ToastDetail = {
  message: string;
};

export function AppToast() {
  const [message, setMessage] = useState('');
  const [visible, setVisible] = useState(false);
  const timeoutRef = useRef<number | null>(null);

  useEffect(() => {
    const onToast = (event: Event) => {
      const detail = (event as CustomEvent<ToastDetail>).detail;
      const nextMessage = detail?.message?.trim();
      if (!nextMessage) return;

      setMessage(nextMessage);
      setVisible(true);
      if (timeoutRef.current) window.clearTimeout(timeoutRef.current);
      timeoutRef.current = window.setTimeout(() => setVisible(false), 2400);
    };

    window.addEventListener('app-toast', onToast as EventListener);
    return () => {
      window.removeEventListener('app-toast', onToast as EventListener);
      if (timeoutRef.current) window.clearTimeout(timeoutRef.current);
    };
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed top-4 right-4 z-[100] pointer-events-none">
      <div className="bg-brand-dark text-white px-4 py-3 rounded-lg shadow-lg text-sm font-medium">
        {message}
      </div>
    </div>
  );
}

